import React from 'react';
import { getDOMNode } from 'libs/dom';
import { useEffect } from 'libs/react';
import { useRef } from 'libs/react';
/**
 * @component Closeable
 * @since 1.0.0
 */
export function Closeable(props) {
    const ref = useRef(null);
    /**
     * @function onClick
     * @since 1.0.0
     * @hidden
     */
    function onClick(e) {
        var _a;
        const node = getDOMNode(ref.current);
        if (node && node.contains(e.target)) {
            return;
        }
        const target = e.target;
        if ((_a = target.closest) === null || _a === void 0 ? void 0 : _a.call(target, '[data-closeable-ignore]')) {
            return;
        }
        if (props.onClose) {
            props.onClose();
        }
    }
    useEffect(() => {
        document.body.addEventListener('click', onClick);
        return () => {
            document.body.removeEventListener('click', onClick);
        };
    }, []);
    return React.createElement(Content, { ref: ref }, props.children);
}
/**
 * @component Content
 * @since 1.0.0
 * @hidden
 */
export class Content extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return this.props.children;
    }
}
